import React, { useEffect, useState } from "react";
import Input from "componentsTemplate/Input/Input";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Textarea from "componentsTemplate/Textarea/Textarea";
import Label from "componentsTemplate/Label/Label";
import Layout from "./layout";
import LayoutDashboard from "./layout/layout";
import FormFieldInput from "components/campos/input";
import FormFieldTextArea from "components/campos/textarea";
import FormFieldFileInput from "components/campos/file";
import PerfilService from "../../services/PerfilService";
import { toast } from "react-toastify";

const useForm = (initialState: any) => {
  const [formData, setFormData] = useState(initialState);

  const handleChange = (fieldName: any, value: any) => {
    setFormData((prevData: any) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  return { formData, handleChange };
};

const Perfil = () => {

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({} as any);

  const getUser = async () => {
    await PerfilService
      .getUser()
      .then((response: any) => {
        setUser(response.data.user);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  useEffect(() => {
    getUser();
  }, []);

  const { formData, handleChange } = useForm({
    name: "",
    last_name: "",
    display_name: "",
    document: "",
    email: "",
    birth_date: "",
    phone: "",
    linkedin: "",
    bibliography: "",

    postal_code: "",
    address: "",
    number: "",
    complement: "",
    district: "",
    country: "",
    city: "",
    state: "",

    companyName: "",
    website: "",
    activity: "",
    position: "",
  });

  useEffect(() => {
    handleChange('name', user.name ?? "");
    handleChange('last_name', user.last_name ?? "");
    handleChange('display_name', user.display_name ?? "");
    handleChange('document', user.document ?? "");
    handleChange('email', user.email ?? "");
    handleChange('birth_date', user.birth_date ?? "");
    handleChange('phone', user.phone ?? "");
    handleChange('linkedin', user.linkedin ?? "");
    handleChange('instagram', user.instagram ?? "");
    handleChange('facebook', user.facebook ?? "");
    handleChange('x', user.x ?? "");
    handleChange('youtube', user.youtube ?? "");
    handleChange('tiktok', user.tiktok ?? "");
    handleChange('bibliography', user.bibliography ?? "");

    handleChange('postal_code', user.address?.postal_code ?? "");
    handleChange('address', user.address?.address ?? "");
    handleChange('number', user.address?.number ?? "");
    handleChange('complement', user.address?.complement ?? "");
    handleChange('district', user.address?.district ?? "");
    handleChange('country', user.address?.country ?? "");
    handleChange('city', user.address?.city ?? "");
    handleChange('state', user.address?.state ?? "");

    handleChange('companyName', user.company?.companyName ?? "");
    handleChange('website', user.company?.website ?? "");
    handleChange('activity', user.company?.activity ?? "");
    handleChange('position', user.company?.position ?? "");
  }, [user]);

  const onChangeImg = (e: any) => {
    const reader = new FileReader();
    const files = e.target.files;

    handleChange("fotoPerfil", files[0]);

    reader.onload = function () {
      handleChange("imagemPerfil", reader.result);
    };

    reader.readAsDataURL(files[0]);
  };

  const enviarDados = async () => {
    // Adicione sua lógica para enviar os dados do formulário

    const newDados = {
      user: {
        name: formData.name,
        last_name: formData.last_name,
        display_name: formData.display_name,
        email: formData.email,
        document: formData.document,
        document_type_id: 1, // CPF
        birth_date: formData.birth_date,
        phone: formData.phone,
        linkedin: formData.linkedin,
        instagram: formData.instagram,
        facebook: formData.facebook,
        x: formData.x,
        youtube: formData.youtube,
        tiktok: formData.tiktok,
        bibliography: formData.bibliography,
      },
      address: {
        country: formData.country,
        state: formData.state,
        city: formData.city,
        postal_code: formData.postal_code,
        address: formData.address,
        number: formData.number,
        district: formData.district,
        complement: formData.complement,
      },
      company: {
        companyName: formData.companyName,
        activity: formData.activity,
        website: formData.website,
        position: formData.position,
      },
    };
   
    await PerfilService.updateUser(newDados)
      .then((response: any) => {
        if (response.id) {
          //alert("Dados editado com sucesso!");
          toast.success("Perfil editado com sucesso!");

          // aguardar 2 segundos
          setTimeout(() => {
            // redirecionar para a página de perfil
            window.location.reload(); // Remover isso e fazer implementar o reload do hook e local storage
          } , 1500);
          // recarrega a tela
          // getUser();
        } else {
          toast.error("Erro ao editar perfil!");
        }
      })
      .catch((error: any) => {
        console.error(error);
        toast.error("Erro ao editar perfil!");
      });
  };
  
  return (
    <Layout user={user}>
      <LayoutDashboard>
        <div className="rounded-xl md:border md:border-neutral-100 dark:border-neutral-800 md:p-6">
          <form className="grid md:grid-cols-2 gap-6" action="#" method="post">
            {[
              ["Nome", "name"],
              ["Sobrenome", "last_name"],
              ["Nome de Exibição", "display_name", "text", { mdColSpan: 2 }, "md:col-span-2"],
              ["CPF", "document"],
              ["Data Nascimento", "birth_date", "date"],
              ["Email", "email"],
              ["WhatsApp", "phone"],
              ["Linkedin (Ex. https://www.linkedin.com/in/exemplo...)", "linkedin"],
              ["Instagram (Ex. https://www.instagram.com/exemplo...)", "instagram"],
              ["Facebook (Ex. https://www.facebook.com/exemplo...)", "facebook"],
              ["X (Ex. https://x.com/exemplo....)", "x"],
              ["Youtube (Ex. https://www.youtube.com/@exemplo...)", "youtube"],
              ["Tiktok (Ex. https://www.tiktok.com/@exemplo...)", "tiktok"],

              ["CEP", "postal_code"],
              ["Rua", "address"],
              ["Complemento", "complement"],
              ["Bairro", "district"],
              ["Cidade", "city"],
              ["Estado", "state"],

              ["Nome da Empresa", "companyName"],
              ["Site", "website"],
              ["Atividade", "activity"],
              ["Cargo", "position"],
            ].map(([label, fieldName, type, extraProps, classe]: any) => (
              <FormFieldInput
                key={fieldName}
                label={label}
                fieldName={fieldName}
                type={type}
                extraProps={extraProps}
                classe={classe}
                formData={formData}
                handleChange={handleChange}
              />
            ))}

            {/* <FormFieldFileInput
              label="Foto Perfil"
              fieldName="fotoPerfil"
              formData={formData}
              handleChange={handleChange}
              classNameImagem={'rounded-full img-perfil-w-h'}
            /> */}

            <FormFieldTextArea
              label={"Biografia"}
              fieldName={"bibliography"}
              extraProps={{ rows: 16 }}
              formData={formData}
              handleChange={handleChange}
            />

            <ButtonPrimary
              className="md:col-span-2"
              type="button"
              onClick={enviarDados}
            >
              Salvar perfil
            </ButtonPrimary>
          </form>
        </div>
      </LayoutDashboard>
    </Layout>
  );
};

export default Perfil;
